enum UserStatus {
  ACTIVE = "Active",
  DEACTIVATED = "Deactivated",
}

export default UserStatus;
